import AssignmentWorkLocationModal from "@app/components/modals/assignments/assignment-work-location-modal.tsx";
import useWorkLocationData from "@app/data-hooks/use-work-location-data.ts";
import { assignmentWorkLocationsTableDefinition } from "@app/table-definitions/assignment-work-locations.table-definition.tsx";
import { Button } from "@mui/material";
import { DataTable } from "bi-lib";
import { useState } from "react";

interface Props {
    id: number;
}

export default function AssignmentWorkLocationsForm({ id }: Props) {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [locationId, setLocationId] = useState<number>();

    const { workLocationsList, updateWorkLocationActivation } = useWorkLocationData({
        assignmentIds: id.toString(),
    });

    return (
        <>
            <AssignmentWorkLocationModal
                open={dialogOpen}
                onClose={() => {
                    setDialogOpen(false);
                    setLocationId(undefined);
                }}
                assignmentId={id}
                locationId={locationId}
            />
            <DataTable
                rowsPerPageOptions={[5000]}
                label={"Work Locations"}
                actions={
                    <Button variant={"contained"} onClick={() => setDialogOpen(true)}>
                        Add New
                    </Button>
                }
                columns={assignmentWorkLocationsTableDefinition({
                    onEdit: (id) => {
                        setDialogOpen(true);
                        setLocationId(id);
                    },
                    onActivateDeactivate: (id, active) =>
                        updateWorkLocationActivation.mutate({
                            locationId: id,
                            isActive: active,
                        }),
                    rowCount: workLocationsList.data?.length ?? 0,
                })}
                data={workLocationsList.data ?? []}
                queryHook={workLocationsList}
            />
        </>
    );
}
